export const stackContent = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
    <style>
        .type-of-fold .heading {
            margin-bottom: 30px;
        }

        .type-of-fold .heading h4 {
            font-size: 20px;
            padding: 0 0 16px;
        }

        .type-of-fold .row {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }

        .type-of-fold-item h5 {
            margin: 0 0 24px;
            font-size: 18px;
        }

        .type-of-fold-item img {
            width: 100%;
            vertical-align: middle;
            height: auto;
            margin: 0 0 30px;
        }

        .type-of-fold-item p {
            margin: 0 0 16px;
        }

        .type-of-fold-item p:last-child {
            margin: 0;
        }

        .type-of-fold-item a {
            text-decoration: underline;
            color: inherit;
        }

        .type-of-fold .heading li {
            position: relative;
            list-style: none;
            padding: 0 0 0 24px;
            margin: 0;
        }

        .type-of-fold .heading ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        .type-of-fold .heading li:before {
            content: "";
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M6 11L9.5 14.5L17.5 6.5" stroke="%234BAD3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            position: absolute;
            top: 1px;
            width: 18px;
            height: 18px;
            background-size: 18px;
            left: 0;
        }

        .type-of-fold-item ul {
            margin: 0;
            padding: 0;
            list-style-position: inside;
        }

        .type-of-fold-item ul li {
            margin: 0 0 2px;
        }

        .type-of-fold-item ul li:last-child {
            margin: 0 0 2px;
        }

        @media (max-width: 767px) {
            .type-of-fold .row {
                grid-template-columns: 1fr;
            }
        }
    </style>
</head>

<body>
    <div class="type-of-fold">
        <div class="row">
            <div class="type-of-fold-item">
                <h5>Couple</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/7_2_1_Inbetween-gordijnen-aantal-delen-1_1759322870950.jpg?v=1759753619" alt="Couple curtain configuration">
                <p>When choosing a pair, the curtain is divided into two equal sections. This allows you to hang a
                    curtain panel on each side of the window. This gives the room a Luxurious look and creates symmetry.
                </p>
            </div>
            <div class="type-of-fold-item">
                <h5>One part left</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/7_2_1_Inbetween-gordijnen-aantal-delen-2_1759322870973.jpg?v=1759753619" alt="One part left curtain">
                <p>If you choose a single panel on the left, the curtain will consist of a single piece of fabric. This
                    means you'll only have a single panel hanging on the left side when the curtain is open. This means
                    there's no panel hanging on the right side, which is extremely convenient if, for example, a large
                    cupboard is located there.</p>
            </div>
            <div class="type-of-fold-item">
                <h5>One part on the right</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/7_2_1_Inbetween-gordijnen-aantal-delen-3_1759322870996.jpg?v=1759753619" alt="One part right curtain">
                <p>If you choose a single panel on the right, the curtain will consist of a single piece of fabric. This
                    means you'll only have a single panel hanging on the right side when the curtain is open. This means
                    there's no panel hanging on the left side, which is extremely convenient if, for example, a large
                    cupboard is located there.</p>
                <p>Unsure about the number of curtain panels? Your personal advisor is ready to help! Schedule a <a
                        href="#">free consultation</a> and get advice on the best option for your window.</p>
                <ul>
                    <li>White</li>
                    <li>Beige</li>
                    <li>Gray</li>
                    <li>Taupe</li>
                    <li>Anthracite</li>
                </ul>
            </div>
        </div>
    </div>
</body>

</html>`;
